import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, createTheme, ThemeProvider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';

const Calendariodejuegos = () => {
  const [imagenesCargadas, setImagenesCargadas] = useState([]);

  const theme = createTheme({
    palette: {
      background: { paper: '#fff' },
      text: { primary: '#45A8D3', secondary: '#1383B3' },
      action: { active: '#001E3C' },
      success: { main: '#009688' },
    },
  });

  useEffect(() => {
    const fetchImagenes = async () => {
      try {
        const response = await axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/programas-sorteos/ultimos');
        setImagenesCargadas(response.data);
      } catch (error) {
        console.error('Error al obtener imágenes:', error);
      }
    };
    fetchImagenes();
  }, []);

  const buscarImagen = (programa) => {
    const imgEncontrada = imagenesCargadas.find((img) =>
      img.programa.toLowerCase().trim() === programa.toLowerCase().trim()
    );
    return imgEncontrada ? imgEncontrada.urlImagen : null;
  };

  const games = [
    {
      title: 'TÓMBOLA',
      img: buscarImagen('Tómbola') || './img/TOMBOLA.jpg',
      subGames: [
        { title: 'Previa', img: buscarImagen('Previa') || './img/TOMBOLA_PREVIA.jpg' },
        { title: 'Primera', img: buscarImagen('Primera') || './img/TOMBOLA_PRIMERA.jpg' },
        { title: 'Matutina', img: buscarImagen('Matutina') || './img/TOMBOLA_MATUTINA.jpg' },
        { title: 'Vespertina', img: buscarImagen('Vespertina') || './img/TOMBOLA_VESPERTINA.jpg' },
        { title: 'Nocturna', img: buscarImagen('Nocturna') || './img/TOMBOLA_NOCTURNA.jpg' },
      ],
    },
    { title: 'QUINI 6', img: buscarImagen('Quini 6') || './img/QUINISORTEO.jpg' },
    { title: 'BRINCO', img: buscarImagen('Brinco') || './img/BRINCOSORTEO.jpg' },
    { title: 'LOTERIA', img: buscarImagen('Lotería') || './img/LOTERIASORTEO.jpg' },
    { title: 'LOTO 5', img: buscarImagen('Loto 5') || './img/LOTO5SORTEO.jpg' },
    { title: 'LOTO PLUS', img: buscarImagen('Loto Plus') || './img/LOTOPLUSSORTEO.jpg' },
    { title: 'POZO DE LA QUINIELA', img: buscarImagen('Pozo de la Quiniela') || './img/QUINIELASORTEO.jpg' },
    { title: 'TOMBO-EXPRESS', img: buscarImagen('Tombo Express') || './img/TOMBOEXPRESSSORTEO.jpg' },
    { title: 'TELEKINO', img: buscarImagen('Telekino') || './img/TELEKINO.jpg' },
    { title: 'BETWARRIOR', img: buscarImagen('Betwarrior') || './img/BETWARRIOR.jpg' },
  ];

  return (
    <ThemeProvider theme={theme}>
      <div className="container my-5 fondotransparente">
        <center>
          <h1 className="p-5 botonbordeazul text-white px-5 mx-5 py-3">Calendario de Juegos</h1>
        </center>
        {games.map((game, index) => (
          <Accordion
            key={index}
            sx={{
              borderRadius: 2,
              p: 1,
              boxShadow: 3,
              '&:not(:last-child)': { marginBottom: 2 },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              sx={{ justifyContent: 'center', textAlign: 'center' }}
            >
              <Typography sx={{ width: '100%', fontSize: 20, textAlign: 'center' }}>
                <strong>{game.title}</strong>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {game.subGames ? (
                game.subGames.map((subGame, subIndex) => (
                  <Accordion
                    key={subIndex}
                    sx={{ boxShadow: 2, '&:not(:last-child)': { marginBottom: 2 } }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`subPanel${subIndex}-content`}
                      id={`subPanel${subIndex}-header`}
                      sx={{ justifyContent: 'center', textAlign: 'center' }}
                    >
                      <Typography sx={{ width: '100%', textAlign: 'center' }}>
                        <strong>{subGame.title}</strong>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <img
                        src={subGame.img}
                        className="centrar img-fluid my-3"
                        alt={subGame.title}
                      />
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <img
                  src={game.img}
                  className="centrar img-fluid my-3"
                  alt={game.title}
                />
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </ThemeProvider>
  );
};

export default Calendariodejuegos;
